import { Stack, useGlobalSearchParams } from 'expo-router';

import { getScreenTitleHeader } from '../../components/get-screen-title-header';
import { fetchQuery } from '../../static/fetch-query';

export default function StaticPageLayout() {
  const { title = '' } = useGlobalSearchParams<{ title: string; staticPage: string }>();
  return (
    <Stack
      screenOptions={{
        header: getScreenTitleHeader({ backStyle: 'close', cannotGoBackHref: '/' }),
        title,
      }}
    />
  );
}

export async function generateStaticParams(): Promise<Record<'staticPage', string>[]> {
  const data = await fetchQuery(`query GetStaticPageRoutes {
        allStaticPages {
            _id
            path {
              current
            }
            localePath {
              en { current }
            }
            includedInSitemap
          }
        }
      `);

  return data.allStaticPages.map(({ path }) => ({
    staticPage: path.current,
  }));
}
